import { Component, Input } from "@angular/core";
import { AlertType } from "./alert.type";

type NewType = string;

@Component({
    selector: "app-alert",
    templateUrl: "./alert.component.html",
    styleUrls: ["./alert.component.scss"]
})
export class AlertComponent {
    @Input()
    public show = false;

    @Input()
    public type: AlertType = AlertType.primary;
    public AlertType = AlertType;

    @Input()
    public message = "";

    public Show(message: NewType, type: AlertType = AlertType.primary): void {
        this.show = true;

        if (type != null) {
            this.type = type;
        }

        if (message != "") {
            this.message = message;
        }
    }

    public Close(): void {
        this.show = false;
    }

    public Clear(): void {
        this.show = false;
        this.message = null;
    }
}
